module.exports = __webpack_public_path__ + "img/plate01_05.3e5c7204.png";